import { Routes } from '@angular/router'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { SearchResultsComponent } from './search-results.component'

export const searchRoutes: Routes = [
  {
    path: 'search',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: SearchResultsComponent,
      },
    ],
  },
]
